import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextareaAutosize } from "@mui/material";
import { useState } from "react";


interface MessageEditorProps {
  message: string;
  onSave: (message: string) => void;
  onClose: () => void;
}

export function MessageEditor({ message, onSave, onClose }: MessageEditorProps) {
  const [text, setText] = useState<string>(message);

  return (
    <Dialog fullWidth maxWidth="md" open={true} onClose={onClose}>
      <DialogTitle>Notes</DialogTitle>
      <DialogContent>
        <Stack direction="column">
          <TextareaAutosize
            value={text}
            onChange={(e) => setText(e.target.value)}
            minRows={8}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button onClick={() => onSave(text)}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
